var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container"},[_c('p',{staticClass:"text-center blue-grey--text display-1 font-weight-black"},[_vm._v("Title 05 View")])])}
var staticRenderFns = []

export { render, staticRenderFns }